import {
  GET_RECENTLY_VIWED_SPACES,
  PATCH_RECENTLY_VIWED_SPACES,
} from '../../constants/endpoints';
import request from '../request';

const getRecentlyViewedSpace = async () => {
  const res = await request({
    method: 'GET',
    url: GET_RECENTLY_VIWED_SPACES(),
  });
  return res;
};

const patchRecentlyViewedSpace = async (data) => {
  const res = await request({
    method: 'PATCH',
    url: PATCH_RECENTLY_VIWED_SPACES(),
    data,
  });

  return res;
};

export { getRecentlyViewedSpace, patchRecentlyViewedSpace };
